(() => {
  const prefillInquiry = (root = document) => {
    const select = root.querySelector('#VelocProductSelect');
    if (!select) return;

    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    if (!requestedProduct) return;

    const matchingOption = Array.from(select.options).find(
      (option) => option.value === requestedProduct,
    );

    if (matchingOption) {
      select.value = requestedProduct;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefillInquiry());
  } else {
    prefillInquiry();
  }

  document.addEventListener('shopify:section:load', (event) => prefillInquiry(event.target));
})();
